export default __webpack_public_path__ + "static/media/Group 7.b5a178d1.png";